function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M476.2 193.1c32.5 61.4 25.6 140.4-10.4 206.3-35.9 65.9-100.8 118.8-175 124.1-74.2 5.3-157.7-36.8-192.4-102.1-34.8-65.2-21-153.6 20.7-220.3 41.8-66.8 111.3-111.9 182.1-112.6 70.7-.7 142.6 43.2 175 104.6z",
  fill: "#6415ff"
});

function SvgSvgDecoratorBlob1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8c3ZnCiAgICAgICAgd2lkdGg9IjYwMCIKICAgICAgICBoZWlnaHQ9IjYwMCIKICAgICAgICB2aWV3Qm94PSIwIDAgNjAwIDYwMCIKICAgICAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCj4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwMCwzMDApIj4KICAgICAgICA8cGF0aCBkPSJNMTc2LjIsLTEwNi45QzIwOC43LC00NS41LDIwMS44LDMzLjUsMTY1LjgsOTkuNEMxMjkuOSwxNjUuMyw2NSwyMTguMiwtOS4yLDIyMy41Qy04My40LDIyOC44LC0xNjYuOSwxODYuNywtMjAxLjYsMTIxLjRDLTIzNi40LDU2LjIsLTIyMi42LC0zMi4yLC0xODAuOSwtOTguOUMtMTM5LjEsLTE2NS43LC02OS42LC0yMTAuOCwxLjIsLTIxMS41QzcxLjksLTIxMi4yLDE0My44LC0xNjguMywxNzYuMiwtMTA2LjlaIgogICAgICAgICAgICAgIGZpbGw9IiM2NDE1ZmYiLz4KICAgIDwvZz4KPC9zdmc+CiAg";
export { SvgSvgDecoratorBlob1 as ReactComponent };